import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

/**
 * Fire-and-forget heartbeat ping while an agent is signed in.
 * - Pings every 30s with the current pathname
 * - Also pings once on page unload with sendBeacon-style fallback
 */
export default function AgentHeartbeat() {
  const { user } = useAuth();
  const loc = useLocation();

  useEffect(() => {
    if (!user || user.role !== "agent") return;
    let cancelled = false;
    const ping = () => {
      if (cancelled) return;
      api.post("/activity/heartbeat", { page: loc.pathname }).catch(() => {});
    };
    ping();
    const id = setInterval(ping, 30000);
    const onLeave = () => { api.post("/activity/logout-ping").catch(() => {}); };
    window.addEventListener("beforeunload", onLeave);
    return () => {
      cancelled = true;
      clearInterval(id);
      window.removeEventListener("beforeunload", onLeave);
    };
  }, [user, loc.pathname]);

  return null;
}
